import { Button, Col, Row, Typography } from "antd";
import React from "react";

import { GENERAL_APPLICATION_LINK, GENERAL_JOB_BOARD_LINK } from "../constants";

import { NoSearchResultsProps } from "./types";

export const NoSearchResults: React.FC<NoSearchResultsProps> = ({
  queryDispatch,
  allowReset,
  queryState,
}) => (
  <Row justify="center" gutter={32} className="fadeInFast">
    <Col span={24}>
      <Typography.Title
        level={2}
        style={{ textAlign: "center", margin: "2rem" }}
      >
        {queryState.locationSlug
          ? "No current openings at this location."
          : "No current openings matched your search criteria."}
      </Typography.Title>
    </Col>
    <Col span={24} style={{ textAlign: "center", margin: "0.5rem" }}>
      {allowReset ? (
        <Button
          type="primary"
          ghost={true}
          onClick={() =>
            queryDispatch({
              type: "reset",
            })
          }
        >
          {"Start over"}
        </Button>
      ) : (
        <Button
          href={GENERAL_JOB_BOARD_LINK}
          type="primary"
          ghost={true}
          target="_blank"
        >
          {"Search all openings"}
        </Button>
      )}
    </Col>
    <Col span={24} style={{ textAlign: "center", margin: "0.5rem" }}>
      <Button href={GENERAL_APPLICATION_LINK} type="primary" target="_blank">
        {"Submit a general application"}
      </Button>
    </Col>
  </Row>
);
